import KeywordMarkupData from '../store/schema/KeywordMarkupData';
import UserNote from 'owa-mail-store/lib/store/schema/UserNote';

export default function getItemUserMarkupMap(
    itemUserHighlights: string[],
    itemUserNotes: UserNote[]
): Map<string, KeywordMarkupData> {
    let keywordToMarkupMap = new Map();

    itemUserHighlights.forEach(highlight => {
        const markup: KeywordMarkupData = { isHighlight: true, isNote: false };
        keywordToMarkupMap.set(highlight, markup);
    });

    itemUserNotes.forEach(note => {
        const { keyword, instance } = note;

        let markup: KeywordMarkupData = keywordToMarkupMap.get(keyword);
        let noteInstances: Set<number> = markup?.noteInstances || new Set();
        noteInstances.add(instance);
        if (markup) {
            markup.isNote = true;
            markup.noteInstances = noteInstances;
        } else {
            markup = {
                isHighlight: false,
                isNote: true,
                noteInstances: noteInstances,
            };
        }

        keywordToMarkupMap.set(keyword, markup);
    });

    return keywordToMarkupMap;
}
